import React, { useEffect, useState } from 'react'
import styles from './style'
import propTypes from './prop'
import { withStyles } from '@material-ui/core'
import {
  Selections,
  AccordionPart,
  BadgeImage,
  SuccessRate,
} from './components'
import { getBadgesAction } from 'src/reducers/card/action'
import { useDispatch, useSelector } from 'react-redux'
import { useCardSettings, patchSetting } from 'src/hooks/useCardSettings'
import { editorLoading } from 'src/reducers/card/action'
import { Icon } from '@iconify/react'

/**
 *
 * @param {*} props
 */

const BadgeCard = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const settings = useCardSettings('badge')
  const badgeSettings = JSON.parse(settings.value)
  const editorLoadingState = useSelector(state => state.card.editorLoading)
  const [badgeUsageType, setBadgeUsageType] = useState(
    badgeSettings.badgeUsageType,
  )

  const [loading, setLoading] = useState(false)
  const handleBadgeUsageType = async badgeType => {
    dispatch(editorLoading())

    patchSetting(
      dispatch,
      settings.cardId,
      settings.id,
      'badge',
      JSON.stringify({
        ...badgeSettings,
        badgeUsageType: badgeType,
      }),
      () => {
        setTimeout(() => {
          dispatch(editorLoading())
          setLoading(false)
        }, 3000)
      },
    )
    setBadgeUsageType(badgeType)
  }
  const [badges, setBadges] = useState([])

  useEffect(() => {
    setLoading(true)
    dispatch(
      getBadgesAction(response => {
        setLoading(false)
        setBadges(response.data)
      }),
    )
  }, [])
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.card}>
          <div className={classes.header}>
            <div className={classes.headerLeft}>
              <Icon icon="streamline:star-badge-solid" width={18} height={18} color="#002E47" />
              <span className={classes.headerTitle}>Issue Badge</span>
            </div>
          </div>
          <div className={classes.divider} />
          <div className={classes.cardContent}>
            <span className={classes.sectionLabel}>Select badge type</span>
            <div className={classes.sectionPadded}>
              <Selections
                handleBadgeUsageType={handleBadgeUsageType}
                badgeUsageType={badgeUsageType}
              />
            </div>
            {badgeUsageType === 1 && (
              <div className={classes.sectionPadded}>
                <SuccessRate badgeSettings={badgeSettings} settings={settings} />
              </div>
            )}
            <span className={classes.sectionLabel}>Badge messages</span>
            <div className={classes.accordionWrapper}>
              <AccordionPart
                settings={settings}
                badgeSettings={badgeSettings}
                badgeUsageType={badgeUsageType}
              />
            </div>
            <span className={classes.sectionLabel}>Badge design</span>
            <div className={classes.badgeImageWrapper}>
              <BadgeImage
                badges={badges}
                settings={settings}
                badgeSettings={badgeSettings}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

BadgeCard.propTypes = propTypes

export default withStyles(styles)(BadgeCard)
